import { CLIENTES_PATH_ROUTE } from '../../pessoa/cliente/routes';

/** Path do Route das Análises de Mercado */
export const CLIENTE_ANALISES_MERCADOS_PATH_ROUTE = 'analises-mercado';

/** Full Path do Route das Análises de Mercado */
export const CLIENTE_ANALISES_MERCADOS_FULL_PATH_ROUTE = `${CLIENTES_PATH_ROUTE}/${CLIENTE_ANALISES_MERCADOS_PATH_ROUTE}`;
